export function getdata() {
	let obj = {
		searchlist:[
			{
				prop: "test1",
				label: '数电票号码',
				type: "input",
			},
			{
				prop: "test2",
				label: '单据状态',
				type: "select",
			},
			{
				prop: "test3",
				label: 'PDF处理状态',
				type: "select",
			},
			{
				prop: "test4",
				label: 'OFD处理状态',
				type: "select",
			},
			{
				prop: "test5",
				label: '发票类型',
				type: "select",
			},
			{
				prop: "test6",
				label: '购方名称',
				type: "input",
			},
			{
				prop: "test7",
				label: '任务批次号',
				type: "input",
			},
			{
				prop:"tes8",
				label:"价税合计",
				type:"inputplus"
			},
			{
				prop: "test9",
				label: '开票日期',
				type: "realdate",
			},{
				prop: "test10",
				label: '最近操作时间',
				type: "input",
			},
		],
		searchdata:{
			tes11:'',
			tes10:'',
			tes9:'',
			tes8:'',
			tes7:'',
			tes6:'',
			tes5:'',
			tes4:'',
			tes3:'',
			tes2:'',
			tes1:'',
		}
	}
	return obj
}